export const CreatePatientOrderDocumentationMarkdown = `
# Create Patient Order

## Description

The Create Patient Order block creates a patient order based on input in the configuration.

## Input Parameters
Payload:

\`\`\`json
{
  "patientEhrId": "string",
  "providerReferenceValue": "string",
  "fileName": "string",
  "procedures": [
    {
      "description": "string",
      "cptCode": "string"
    }
  ],
  "rawDiagnoses": "string (optional)",
  "referralComment": "string",
  "referralPriority": "enum",
  "externalDocumentPacketId": "uuid: string",
  "orderSpecificQuestions": [
    {
      "question": "string",
      "code": "string",
      "answer": "string (optional)"
    }
  ]
}
\`\`\`

## Output

The block creates an encounter summary in Notable and returns the patient order.

## Usage

This is necessary before exporting an order via EXPORT_REFERRAL_ORDER / EXPORT_REFERRAL_DOCUMENT jobs.
`;
